
import template from "./pLogin.html";

export function pLoginDirective() {
  'ngInject';

  let directive = {
    restrict: 'E',
    template: template,
    controller: pLoginController,
    controllerAs: 'pLogin',
    bindToController: true
  };

  return directive;
}

class pLoginController {
  constructor ($log, $scope, $location, $routeParams, Auth, Language, Bundle, $sce) {
    'ngInject';
    this.$location = $location;
    this.Auth = Auth;
    this.Language = Language;
    this.hideSso = false;
    this.Bundle = Bundle;
    this.$sce = $sce;

    if($routeParams.oneTimeToken) {
      this.state = "sending";

      this.Auth.samlLogin($routeParams.oneTimeToken).then((loginSuccess) => {
        this.Auth.getRefreshToken(loginSuccess.data.token).then((refreshToken) => {
          this.Auth.setupRefreshToken(refreshToken);
          return this.Auth.authorize().then(() => {
            this.$location.path("/");
          });
        });
      }, (error) => {
        this.state = "error";
        this.error = error;
      });
    } else {
      if($routeParams.reloginRefreshToken) {
        this.Auth.setupRefreshToken({
          data: {
            value: JSON.parse($routeParams.reloginRefreshToken)
          }
        });
      }

      this.Auth.authorize().then(
        () => {
          const search = this.$location.search();
          if (search.next) {
            this.$location.url(decodeURIComponent(search.next));
          } else {
            this.$location.path("/");
          }
        },
        () => {
          this.state = "form";
        }
      );
    }
  }

  login() {
    this.state = "sending";
    this.showCode  = false;

    this.Auth.login(this.email, this.password, this.unlockCode).then((loginSuccess) => {
      this.showCode  = false;
      this.Auth.getRefreshToken(loginSuccess.data.token).then((refreshToken) => {
        this.Auth.setupRefreshToken(refreshToken);
        return this.Auth.authorize().then(() => {
          const search = this.$location.search();
          if (search.next) {
            this.$location.url(decodeURIComponent(search.next));
          } else {
            this.$location.path("/");
          }
        });
      });
    }, (error) => {
      this.state = "error";
      this.error = error;
      if (this.error.status == 423) {
        this.showCode  = true;
      }
    });
  }

  loginSso() {
    this.state = "sending";
    this.getIdpUrl().then(() =>
    this.Auth.getSamlRequest().then((samlRequest) => {
      this.samlRequest = samlRequest.data;
      setTimeout(() => document.querySelector(".ssoForm").submit(), 1);
    }, (error) => {
      this.state = "error";
      this.error = error;
    }));
  }

  sendAgain() {
    this.Auth.sendMailWithCodeAgain(this.email).then(() => {
      this.state = "mailSent";
    }, (error) => {
      this.state = "error";
      this.error = error;
    });
  }

  getIdpUrl() {
    return this.Auth.getIdpUrl().then((url) => {
      this.idpUrl = this.$sce.trustAsResourceUrl(url.data);
    }, (error) => {
      this.state = "error";
      this.error = error;
    });
  }
}